export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

const getParams = (url: string) => {
  const parts = url.split('?');
  if (parts.length > 1) {
    return '?' + parts[1];
  }

  return url;
}

export function checkIsActive(pathname: string, url: string, search?: string, exactUrl?: boolean, parent?: string) : boolean {
  let current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  if (exactUrl && search && search.length > 0) {
    current = `${current}${search}`
  }

  if (getParams(url) === search) {
    return true
  }

  if (current === url) {
    return true
  }

  if (!exactUrl && current.indexOf(url) > -1) {
    return true
  }

  // v2: also check parent relationship
  if (parent && current.includes(url)) {
    return true
  }

  return false
}
